import { type InquiryForm, type InquiryItem } from '../../../models/Inquiry/Inquiry';

interface Props {
  data: InquiryForm
  formValues: Record<string, any>
  onBack: () => void
}

const getDisplayValue = (value: any, type: number): string => {
  if (!value) return '-';

  // Handle different types
  switch (type) {
    case 3: // checkbox
      return Array.isArray(value) ? value.join(', ') : value;
    case 4: // radio
    case 5: // select
      return value;
    default:
      return String(value);
  }
};

const ConfirmRow = ({ label, value, type }: { label: string; value: any; type: number }) => (
  <div className="row mb-3">
    <div className="col-sm-3">
      <label className="col-form-label fw-bold">{label}</label>
    </div>
    <div className="col-sm-9">
      <div className="col-form-label">
        {getDisplayValue(value, type)}
      </div>
    </div>
  </div>
);

export default function InquiryPreviewConfirm({ data, formValues, onBack }: Props) {
  return (
    <>
      {/* Header */}
      <div className="card">
        <div className="card-body">
          <div className="card-title fw-bold fs-4 font-sm mb-1">
            {data?.name}
          </div>
          <p className="card-text" style={{ whiteSpace: 'pre-wrap' }}>
            {data?.description}
          </p>
        </div>
      </div>

      {/* Confirmation Content */}
      <div className="card">
        <div className="card-body">
          {/* <div className="mb-3 text-center">
            <h5>入力内容の確認</h5>
            <p className="text-muted">以下の内容で送信します。よろしいですか？</p>
          </div> */}

          {data?.definition?.map((item: InquiryItem) => {
            if (item?.children?.length) {
              return item.children.map((child) => (
                <ConfirmRow
                  key={child.uuid}
                  label={child.label}
                  value={formValues[`${item.item_id}__${child.item_id}`]}
                  type={child.type}
                />
              ));
            }
            return (
              <ConfirmRow
                key={item.uuid}
                label={item.label}
                value={formValues[item.item_id]}
                type={item.type}
              />
            );
          })}
        </div>

        {/* Action Buttons */}
        <div className="card-footer border-top bg-white text-center">
          <button
            type="button"
            className="btn btn-outline-secondary"
            onClick={onBack}
          >
            キャンセル
          </button>
          <button type="button" className="btn btn-primary mx-2" disabled>
            <span className="mx-2">送信する</span>
          </button>
        </div>
      </div>
    </>
  );
}
